import React from 'react';
import * as SocietyLogos from 'src/images/societies';
import { BRANDING_CONFIG } from 'shared/constants/branding.constants';
import styles from './branding-logo.module.scss';

export function BrandingLogo({ brandName }) {
  const branding = BRANDING_CONFIG[brandName];

  if (!branding) {
    return null;
  }

  const logo = SocietyLogos[branding.logoName];

  if (!logo) {
    return null;
  }

  return (
    <div className={styles.branding}>
      <img 
        src={logo} 
        alt={branding.altText || brandName} 
        className={styles.brandLogo}
      />
    </div>
  );
}